import AuthenticationStorageService from './authentication-storage-service'
export { default as AuthenticationTokenService } from './authentication-token-service'

const authenticationStorage = new AuthenticationStorageService()

export default authenticationStorage
